import "./libs/slick";
import "./libs/jcf/jcf.js";
import "./libs/jcf/jcf.scrollable.js";
import "./libs/jcf/jcf.select.js";

import {binder} from "./libs/binder";
import {constants} from "./modules/module";
import {fullHeightPage} from "./modules/fullHeightPage";
import {mobileNav} from "./modules/mobileNav";
import {stickyHeader} from "./modules/stickyHeader";
import {newsSlider} from "./modules/newsSlider";
import {testimonialsSlider} from "./modules/testimonialsSlider";
import {resourcesBanner} from "./modules/resourcesBanner";
import {ourNumbersSlider} from "./modules/ourNumbersSlider";
import {ourSpecialtiesList} from "./modules/ourSpecialtiesList";
import {benefitsCardSlider} from "./modules/benefitsCardSlider";
import {customSelect} from "./modules/customSelect";
import {customTabsBlock} from "./modules/customTabsBlock";
import {sensitiveContent} from "./modules/sensitiveContent";
import {articleDoctorsSlider} from "./modules/articleDoctorsSlider";
import {copyLinkToBuffer} from "./modules/copyLinkToBuffer";
import {anchors} from "./modules/anchors";
import {accordion} from "./modules/accordion";
import {infoCardsList} from "./modules/infoCardsList";
import {resetFormFilters} from "./modules/resetFormFilters";
import {servicesWithIcon} from "./modules/servicesWithIcon";
import {featuresServicesSlider} from "./modules/featuresServicesSlider";
import {benefitsGallery} from "./modules/benefitsGallery";
import {ourMissionSlider} from "./modules/ourMissionSlider";
import {ourHistorySlider} from "./modules/ourHistorySlider";
import {fullWidthCarousel} from "./modules/fullWidthCarousel";
import {quoteSmallSlider} from "./modules/quoteSmallSlider";
import {popups} from "./modules/popups";
import {showMoreServices} from "./modules/showMoreServices";
import {articleVideo} from "./modules/articleVideo";
import {animationOnScroll} from "./modules/animationOnScroll";
import {countersAnimation} from "./modules/countersAnimation";
import {featuresListSlider} from "./modules/featuresListSlider";
import {hashScroll} from "./modules/hashScroll";
import {articleAnchorList} from "./modules/articleAnchorList";
import {customForm} from "./modules/customForm";
import {fileUpload} from "./modules/fileUpload";
import {tabs} from "./modules/tabs";
import {copyPhone} from "./modules/copyPhone";


binder({
    bounds: {
        "html": [constants, fullHeightPage, hashScroll],
        ".header": [mobileNav, stickyHeader],
        "select": customSelect,
        ".news-list.has-slider": newsSlider,
        ".testimonials-section-slider": testimonialsSlider,
        ".resources-banner": resourcesBanner,
        ".our-numbers-slider": ourNumbersSlider,
        ".our-specialties-list.has-slider": ourSpecialtiesList,
        ".benefits-card-list.has-slider": benefitsCardSlider,
        ".custom-tabs-block": customTabsBlock,
        ".sensitive-content": sensitiveContent,
        ".article-doctors-slider": articleDoctorsSlider,
        ".copy-link": copyLinkToBuffer,
        ".has-anchor": anchors,
        ".accordion": accordion,
        ".info-cards-list.has-slider,.info-cards-list.slider": infoCardsList,
        ".form-filters": resetFormFilters,
        ".services-with-icon": servicesWithIcon,
        ".features-services-slider": featuresServicesSlider,
        ".benefits-gallery": benefitsGallery,
        ".our-mission-slider": ourMissionSlider,
        ".our-history-slider": ourHistorySlider,
        ".full-width-carousel": fullWidthCarousel,
        ".quote-small-slider": quoteSmallSlider,
        ".popup-opener": popups,
        ".show-more-results": showMoreServices,
        ".details-gallery": articleVideo,
        ".has-animation": animationOnScroll,
        ".has-counters-animation": countersAnimation,
        ".features-list.has-slider": featuresListSlider,
        ".single-article-title .anchors-block": articleAnchorList,
        ".next-custom-form": customForm,
        "input[type='file']": fileUpload,
        ".tabs-holder": tabs,
        ".emergency-contact": copyPhone,
    },
    runTests: false
});



// WEBPACK FOOTER //
// ./assets/js/global.js